/* eslint-disable */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { wget } from 'lodash';
import { connect } from 'react-redux';
import { BarLoader, Button, Filter, Pager } from '@unite-us/app-components';
import {
  useInvalidateQueries,
} from 'src/api/APIHooks';
import { browserHistory } from 'common/utils/browserHistory';
import { getContactFromState } from 'src/components/Contacts/utils';
import { useEligibilityAssessments } from 'src/pages/facesheet/_id/eligibility/hooks/useEligibilityAssessments';
import {
  USE_MY_SCREENINGS_KEY,
} from 'src/pages/facesheet/_id/eligibility/hooks/eligibilityApi';
import EligibilityAssessmentsTable from 'src/pages/facesheet/_id/eligibility/components/EligibilityAssessmentsTable';
import {
  useAssessmentFiltering,
  STATUS_FILTER_OPTIONS,
} from 'src/pages/facesheet/_id/eligibility/hooks/useAssessmentFiltering';

export function EligibilityAssessments({
  contact,
  children,
}) {
  const invalidateQueries = useInvalidateQueries();
  const { data: assessments, isFetching } = useEligibilityAssessments(contact.id);

  const {
    sortBy,
    sortDirection,
    hasFilters,
    paginatedAssessments,
    totalCount,
    paging,
    orgFilterOptions,
    nameFilterOptions,
    submitterFilterOptions,
    dateFilterOptions,
    onSortChange,
    onFiltersChange,
    onNextClick,
    onPrevClick,
  } = useAssessmentFiltering(assessments);

  useEffect(() => {
    invalidateQueries(USE_MY_SCREENINGS_KEY);
  }, []);

  const emptyMessage = hasFilters
    ? 'No eligibility assessments match your search criteria. Please try adjusting the filters and search again.'
    : `There are no eligibility assessments for ${contact.full_name}`;

  if (children) {
    return children;
  }

  return (
    <div className="px-5">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="form-name mr-5 my-2">
          {`${totalCount} Eligibility Assessment${totalCount !== 1 ? 's' : ''}`}
        </h2>
        <Button
          id="add-new-assessment"
          label="Add New Assessment"
          icon={{ name: 'Add', position: 'left', color: 'white' }}
          primary
          onClick={() => browserHistory.push(`/facesheet/${contact.id}/eligibility/new`)}
        />
      </div>
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-[5px]">
          <Filter
            key="name"
            name="Form"
            pluralName="Forms"
            options={nameFilterOptions}
            onFiltersChange={(activeFilters) => onFiltersChange('name', activeFilters)}
            filterKey="name"
            uniqIdPrefix="name"
          />
          <Filter
            key="submitter"
            name="Submitter"
            pluralName="Submitters"
            options={submitterFilterOptions}
            onFiltersChange={(activeFilters) => onFiltersChange('submitter', activeFilters)}
            filterKey="submitter"
            uniqIdPrefix="submitter"
          />
          <Filter
            key="status"
            name="Status"
            pluralName="Statuses"
            options={STATUS_FILTER_OPTIONS}
            onFiltersChange={(activeFilters) => onFiltersChange('status', activeFilters)}
            filterKey="status"
            uniqIdPrefix="status"
          />
          <Filter
            key="organization"
            name="Organization"
            pluralName="Organizations"
            options={orgFilterOptions}
            onFiltersChange={(activeFilters) => onFiltersChange('organization', activeFilters)}
            filterKey="organization"
            uniqIdPrefix="organization"
          />
          <Filter
            key="date"
            name="Last Updated"
            pluralName="Dates"
            options={dateFilterOptions}
            onFiltersChange={(activeFilters) => onFiltersChange('date', activeFilters)}
            filterKey="date"
            uniqIdPrefix="date"
          />
        </div>
        <div className="pager-container">
          <Pager
            paging={paging}
            disabled={isFetching}
            onNextClick={onNextClick}
            onPrevClick={onPrevClick}
          />
        </div>
      </div>
      {isFetching ? (
        <BarLoader className="h-60" size="full" />
      ) : (
        <EligibilityAssessmentsTable
          assessments={paginatedAssessments}
          contactId={contact.id}
          sortBy={sortBy}
          sortDirection={sortDirection}
          onSortChange={onSortChange}
          emptyMessage={emptyMessage}
        />
      )}
    </div>
  );
};

EligibilityAssessments.propTypes = {
  contact: PropTypes.object.isRequired,
  children: PropTypes.node,
};

EligibilityAssessments.defaultProps = {
  children: null,
};

function mapStateToProps(state, ownProps) {
  const contactId = wget(ownProps, 'params.id', '');
  const contact = getContactFromState(state, contactId);
  const currentProvider = state.globalState.currentProvider.group;
  return {
    contact,
    provider: currentProvider,
  };
}

export default connect(mapStateToProps)(EligibilityAssessments);
